module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfBBc-.adcde98f.adcde98f.woff";